import { HubTab, HubTabList, HubTabPanel, HubTabs } from "./HubTabs.jsx";

import HubProductionList from "./HubProductionList.jsx";
import { Localization } from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";

import { scssVariables } from "../../common/util/config.jsx";
import { withRouter } from "react-router-dom";

class HubProductionCard extends React.PureComponent {
    constructor(props) {
        super(props);

        this.swallowOnClick = this.swallowOnClick.bind(this);
        this.calculateInternalPanelHeight = this.calculateInternalPanelHeight.bind(this);

    }

    swallowOnClick(event) {
        event.stopPropagation();
        event.preventDefault();
    }


    calculateInternalPanelHeight() {
        let tabPanelHeight = this.props.height;

        // Remove height of tab panel
        tabPanelHeight -= parseInt(scssVariables.menuHeightWithBorder);
        return tabPanelHeight;
    }

    render() {
        const {
            height,
            localization,
            setModal,
            width,
            customerProductionList,
            editedCustomer,
        } = this.props;
        const tabPanelHeight = this.calculateInternalPanelHeight();

        return (
            <div className={"card-default"} style={{ display: "flex", flexDirection: "column", height: `${height}px`, width: `${width}px` }}>
                <HubTabs startTabId={0}>
                    <HubTabList >
                        <HubTab id={""} label={localization.text("hub", "production", "customers")} />
                    </HubTabList>
                    <HubTabPanel>
                        <HubProductionList
                            height={tabPanelHeight}
                            list={customerProductionList}
                            localization={localization}
                            setModal={setModal}
                            editedCustomer={editedCustomer}
                        />
                    </HubTabPanel>
                </HubTabs>
            </div>
        );
    }
}

HubProductionCard.propTypes = {
    deviceType: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    history: PropTypes.object.isRequired,
    localization: Localization.propTypes.isRequired,
    location: PropTypes.object.isRequired,
    setModal: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    customerProductionList: PropTypes.array.isRequired,
    editedCustomer: PropTypes.object.isRequired,
};

HubProductionCard.defaultProps = {
    currentView: "all",
};
export default withRouter(HubProductionCard);
